const upgrades = {
  init() {
    $(`.upgradeList label`).on("click", $.proxy(this.displayFields, this));
  },

  displayFields(e) {

    let target = $(e.currentTarget).parent().parent().find(`.needSelected`);
    $(target).each(function () {
      ($(this).hasClass(`hidden`)) ? $(this).removeClass(`hidden`) : $(this).addClass(`hidden`);
    });
  },

}

export default upgrades.init();